import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditDeviceReportTable from "../components/Devices";

export default function AuditDeviceReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('Device report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditDeviceReportTable />
        </Layout>
    )
}